export enum RadioGroupExpressions {
  DS_ITEM_1A = 'descriptionItem1a',
  DS_ITEM_1B = 'descriptionItem1b',
  DS_ITEM_1C = 'descriptionItem1c',
  DS_ITEM_2  = 'descriptionItem2',
  DS_ITEM_3  = 'descriptionItem3',
  DS_ITEM_4A = 'descriptionItem4a',
  DS_ITEM_4B = 'descriptionItem4b',
  DS_ITEM_4C = 'descriptionItem4c',
  DS_ITEM_5  = 'descriptionItem5',
  DS_ITEM_6A = 'descriptionItem6a',
  DS_ITEM_6B = 'descriptionItem6b',
  DS_ITEM_6C = 'descriptionItem6c',
  DS_ITEM_7A = 'descriptionItem7a',
  DS_ITEM_7B = 'descriptionItem7b',
  DS_ITEM_8A = 'descriptionItem8a',
  DS_ITEM_8B = 'descriptionItem8b',
  DS_ITEM_8C = 'descriptionItem8c',
  DS_ITEM_9  = 'descriptionItem9',
  DS_ITEM_10 = 'descriptionItem10',
  DS_ITEM_11 = 'descriptionItem11',
  DS_ITEM_12 = 'descriptionItem12',
  DS_ITEM_13 = 'descriptionItem13',
  DS_ITEM_14 = 'descriptionItem14',
  DS_ITEM_15 = 'descriptionItem15',
  DS_ITEM_16 = 'descriptionItem16',
  DS_ITEM_17 = 'descriptionItem17',
  DS_ITEM_18 = 'descriptionItem18',
  DS_ITEM_19 = 'descriptionItem19',
  DS_ITEM_20 = 'descriptionItem20',
  DS_ITEM_21 = 'descriptionItem21',
  DS_ITEM_22 = 'descriptionItem22',
  DS_ITEM_23 = 'descriptionItem23',
}